import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, Route, Routes } from 'react-router';
import styled from 'styled-components';
import { Button, Col, Div, Icon, Row } from 'ui';
import { withShadow } from 'ui/styles';
import { withRouter } from 'utils/withRouter';
import ActionSidepanel from '../../../tickets/components/smart-action-sidepanel/action-sidepanel';
// eslint-disable-next-line max-len
import { getTicket, getTicketActionTypes } from '../../../tickets/containers/form/ticket-form-actions';
import { createOrder } from '../../create/containers/create-order-actions';

const IconContainer = styled.div`
  background-color: #9013FE;
  width: 26px;
  height: 26px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
`;

const StyledIcon = styled(Icon)`
  font-size: 16px;
  color: white;
`;

const Wrapper = styled.div`
  margin: 20px 0 20px 0;
  display: flex;
  padding: 10px 20px;
  flex-direction: column;
  background-color: #fff;
  ${withShadow};
  border-radius: 4px;
`;

const Title = styled.p`
  font-weight: 700;
  font-size: 17px;
`;

const Header = styled(Div)`
  display: flex;
  align-items: center;
  height: 40px;
`;

const StyledBtn = styled(Button)`
  width: 100%;
  text-transform: uppercase;
  color: white;
  ${p => p.type === 'primary' && 'background-color: rgb(0, 152, 204);'}
  &:first-child {
    margin-bottom: 15px;
  }
`;

const RequestToPlan = ({
  orderId,
  smartActionLinkingInfo,
  intl,
  history,
}) => {
  const dispatch = useDispatch();
  const {
    ticket,
    context,
  } = useSelector(state => state.ticketForm);
  const ticketId = smartActionLinkingInfo?.suggestedTicketId;
  const actionTicketId = smartActionLinkingInfo?.suggestedTicketActionId;
  const isAbleToLinkDirectly =
    ticketId && actionTicketId && smartActionLinkingInfo?.availableSmartActionsCount === 1;

  useEffect(() => {
    if (ticketId) {
      dispatch(getTicket({
        id: ticketId,
        isNew: false,
      }));
    }
  }, [ticketId]);

  useEffect(() => {
    if (context?.type && ticket) {
      dispatch(getTicketActionTypes({
        objectType: context?.type,
        id: ticketId,
      }));
    }
  }, [context?.type, ticketId]);

  const linkToSmartTicket = () => {
    if (actionTicketId) {
      history.push(
        `smart-action/visit/${actionTicketId}`,
        { cancelBlock: true },
      );
    }
  };

  const openTicket = () => {
    history.push(`/ticket/${smartActionLinkingInfo?.suggestedTicketNumber}/${ticketId}`);
  };

  const assignOrderToSmartAction = () => {
    dispatch(createOrder({
      scheduledId: orderId,
      type: context?.type,
      id: ticket?.sourceObjectId,
      ticketActionId: actionTicketId,
      assignedToAction: true,
    }));
  };

  return (
    <>
      <Wrapper>
        <Row gutter={16}>
          <Col span={15}>
            <Header>
              <IconContainer>
                <StyledIcon type={'wand-magic-sparkles'} />
              </IconContainer>
              <Title>{intl.formatMessage({ id: 'common.filterGroups.planvisit' })}</Title>
            </Header>
            <FormattedMessage
              id={`ticket.smart_actions.INFO_LINK_TICKET${isAbleToLinkDirectly ?
                '' : '_MULTI'
                }`}
            />
          </Col>
          <Col span={9}>
            {isAbleToLinkDirectly && <StyledBtn
              onClick={linkToSmartTicket}
              type='primary'
            >
              {intl.formatMessage({ id: 'ticket.smart_actions.LINK_SMART_TICKET' })}
            </StyledBtn>}
            <StyledBtn
              onClick={isAbleToLinkDirectly ?
                openTicket :
                // eslint-disable-next-line max-len
                () => history.push(`/tickets/filters/visitactionstatus||0|~|object||${smartActionLinkingInfo?.equipmentId}/view/ticket_none`)}
              light={true}
              type={isAbleToLinkDirectly ? 'secondary' : 'primary'}
            >
              {isAbleToLinkDirectly ?
                intl.formatMessage({ id: 'ticket.smart_actions.OPEN_SMART_TICKET' }) :
                intl.formatMessage({ id: 'common.OPEN_WORKLIST' })
              }
            </StyledBtn>
          </Col>
        </Row>
      </Wrapper>
      <Routes>
        <Route
          path={'smart-action/:actionTypeId/:actionId?'}
          element={<ActionSidepanel
            assignOrderToSmartAction={assignOrderToSmartAction}
            openTicket={openTicket}
            ticket={ticket}
            context={context}
            origin='order'
          />}
        />
      </Routes>
      <Outlet />
    </>);
};

RequestToPlan.propTypes = {
  orderId: PropTypes.string,
  intl: PropTypes.object,
  history: PropTypes.object,
  smartActionLinkingInfo: PropTypes.object,
};

export default withRouter(injectIntl(RequestToPlan));
